// extracted by mini-css-extract-plugin
module.exports =  {"sticky-footer":"YPepNu_","stickyFooter":"YPepNu_","contact-btn":"Dk9MFTj","contactBtn":"Dk9MFTj"};